module.exports = __webpack_public_path__ + "img/channel-sidebar.364053e5.svg";